import { z } from 'zod';
import { Id, UnitInterval, Uri, cursorPage } from './common.js';

export const TranscriptWord = z.object({
  /** word */
  w: z.string(),
  /** start_ms */
  s: z.int(),
  /** end_ms */
  e: z.int(),
});
export type TranscriptWord = z.infer<typeof TranscriptWord>;

export const TranscriptSegment = z.object({
  text: z.string(),
  s: z.int(),
  e: z.int(),
});
export type TranscriptSegment = z.infer<typeof TranscriptSegment>;

export const Transcript = z.object({
  id: Id,
  version_id: Id,
  language: z.string(),
  model: z.string().optional(),
  words: z.array(TranscriptWord),
  segments: z.array(TranscriptSegment),
});
export type Transcript = z.infer<typeof Transcript>;

/** Box in normalized 0–1 coordinates relative to intrinsic media size, origin top-left. */
export const NormalizedBox = z
  .object({
    x: UnitInterval,
    y: UnitInterval,
    w: UnitInterval,
    h: UnitInterval,
  })
  .refine((b) => b.x + b.w <= 1 + 1e-9 && b.y + b.h <= 1 + 1e-9, {
    message: 'box exceeds the 0–1 media bounds',
  });
export type NormalizedBox = z.infer<typeof NormalizedBox>;

export const DetectedRegion = NormalizedBox.extend({
  id: Id,
  version_id: Id,
  frame_t_ms: z.int().nullable().optional(),
  label: z.string(),
  confidence: UnitInterval,
  person_cluster_id: Id.nullable().optional(),
});
export type DetectedRegion = z.infer<typeof DetectedRegion>;

export const PersonCluster = z.object({
  id: Id,
  workspace_id: Id,
  name: z.string().nullable(),
  hidden: z.boolean().optional(),
  face_count: z.int(),
  asset_count: z.int(),
  sample_thumbnail_url: Uri.nullable().optional(),
});
export type PersonCluster = z.infer<typeof PersonCluster>;

export const PersonClusterPage = cursorPage(PersonCluster);
export type PersonClusterPage = z.infer<typeof PersonClusterPage>;

/** Inline body of `PATCH /workspaces/{id}/people/{clusterId}` (not a named component). */
export const PersonClusterUpdate = z.object({
  name: z.string().max(120).nullable().optional(),
  hidden: z.boolean().optional(),
});
export type PersonClusterUpdate = z.infer<typeof PersonClusterUpdate>;
